// only accepted import occurrence:
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/navigation';

import { IPath } from '@/types/IPath';

export const useAppPush = () => {
  const { push: nextjsPush, replace: nextjsReplace } = useRouter();
  const push = (pathname: IPath) => {
    nextjsPush(pathname);
  };

  const replace = (pathname: IPath) => {
    nextjsReplace(pathname);
  };

  return { push, replace };
};
